import React, { createContext, useContext } from "react";
import { Outlet } from "react-router-dom";

const MboSalePaymentWorkingContext = createContext();

const MboSalePaymentWorkingProvider = () => {
	return (
		<MboSalePaymentWorkingContext.Provider value={{}}>
			<Outlet />
		</MboSalePaymentWorkingContext.Provider>
	);
};

export const MboSalePaymentWorkingState = () => {
	return useContext(MboSalePaymentWorkingContext);
};

export default MboSalePaymentWorkingProvider;
